module.exports = __webpack_public_path__ + "static/media/ic-boats.8b4a8196.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-boats.svg
// module id = 602
// module chunks = 14